import { makeStyles, Theme } from '@material-ui/core'

export const useValueLabelStyles = (
  textAlign?: 'left' | 'right',
  fullWidth?: boolean,
  disableMinWidth?: boolean,
  onClick?: boolean
) =>
  makeStyles((theme: Theme) => ({
    // this will reproduce MUI TextField's styles
    valueLabelRoot: {
      // width: '5rem',
      width: fullWidth ? 'fit-content' : 'initial',
      border: '0',
      margin: '0',
      display: 'inline-flex',
      padding: '0',
      position: 'relative',
      minWidth: disableMinWidth ? 0 : theme.spacing(7),
      whiteSpace: 'nowrap',
      flexDirection: 'column',
      verticalAlign: 'top',
      justifyContent: 'space-between',
      alignItems: textAlign === 'left' ? 'flex-start' : 'flex-end',
    },
    label: {
      textAlign: textAlign || 'right',
      transformOrigin: 'top right',
      transform: 'translate(0, -3.5px)',
      // width: '100%',
    },
    value: {
      textAlign: textAlign || 'right',
      padding: '0px 0 2px',
      cursor: onClick ? 'pointer' : 'default',
      textDecoration: onClick ? 'underline' : 'none',
    },
  }))()
